import React, { useEffect, useMemo, useRef, useState } from 'react';
import css from './RatingAndComment.module.css';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import Form from '../Form/Form';
import FieldReviewRating from '../FieldReviewRating/FieldReviewRating';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import * as validators from '../../util/validators';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as BlankProfileImg } from '../../assets/svg/Blank_Profile.svg';
import { ReactComponent as DownArrow } from '../../assets/svg/downArrow.svg';
import { ReactComponent as UpArrow } from '../../assets/svg/upArrow.svg';
import Button, { InlineTextButton } from '../Button/Button';
import { ReactComponent as NoRating } from '../../assets/svg/noRating.svg';
import Modal from '../Modal/Modal';
import arrayMutators from 'final-form-arrays';
import { ReactComponent as VerifiedTickComponent } from '../../assets/svg/verifiedBatch.svg';
import StarRating from '../StarRating/StarRating';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import classNames from 'classnames';
import { getUserReviews } from '../../ducks/user.duck';
import { useDispatch, useSelector } from 'react-redux';
import { createInstance } from '../../util/sdkLoader';
import config from '../../config';
function RatingAndComment(props) {
  const {
    intl,
    currentUser,
    staffData,
    onManageDisableScrolling,
    history,
    disableForShow,
    write,
    reviewsDB,
    showDetailedReviews = true,
    ratingPointContainerClassName,
  } = props;

  const formRef = useRef(null);
  const sdkInstance = useRef(createInstance({ clientId: config.sdk.clientId }));
  const [reviewsSeeMore, setReviewsSeeMore] = useState([]);
  const [isValidReview, setIsValidReview] = useState([]);
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const isSuperAdmin = currentUser?.attributes?.profile?.publicData?.isSuperAdmin;
  const StaffName = staffData?.data?.attributes?.profile?.displayName;
  const staffDataIsProvider = staffData?.data?.attributes?.profile?.publicData?.isProvider;
  const [openRateModal, setOpenRateModal] = useState(false);
  const [submitReviewLoading, setSubmitReviewLoading] = useState(false);
  const [alreadyRatedByCurrentUser, setAlreadyRatedByCurrentUser] = useState(null);
  const [reviews, setReviews] = useState({ data: [] });
  const [reply, setReply] = useState({ text: '', _id: null });
  const [detailReviewClick, setDetailReviewClick] = useState(false);
  const [clickedIndex, setClickedIndex] = useState();
  const reviewUrl = useMemo(() => {
    if (currentUser?.id?.uuid !== undefined && staffData?.data?.id?.uuid !== undefined) {
      return `${apiBaseUrl()}/api/reviews/fetchIsReviewedByUser`;
    }
    return null;
  }, [currentUser?.id?.uuid, staffData?.data?.id?.uuid]);

  const queryStaffDataReviewUrl = useMemo(() => {
    if (staffData?.data?.id?.uuid !== undefined) {
      return `${apiBaseUrl()}/api/reviews/queryReviews`;
    }
    return null;
  }, [currentUser?.id?.uuid, staffData?.data?.id?.uuid]);

  const getReviewByBusiness = () => {
    const oldReview = {};
    if (alreadyRatedByCurrentUser && alreadyRatedByCurrentUser.reviewId) {
      const review = (reviewsDB.data || []).find(r => r._id === alreadyRatedByCurrentUser.reviewId);
      if (review) {
        oldReview.collaboration = review.condition_collaboration.toString();
        oldReview.efficiency = review.expectation_efficiency.toString();
        oldReview.presentation = review.workload_presentation.toString();
        oldReview.punctuality = review.communication_punctuality.toString();
        oldReview.message = review.message;
      }
    }
    return oldReview;
  };
  const businessOldReview = getReviewByBusiness();

  useEffect(() => {
    if (reviewUrl)
      axios
        .post(`${apiBaseUrl()}/api/reviews/fetchIsReviewedByBusiness`, {
          businessId: currentUser?.id?.uuid,
          workerId: staffData?.data?.id?.uuid,
        })
        .then(res => {
          setAlreadyRatedByCurrentUser(res.data);
        })
        .catch(e => {
          setAlreadyRatedByCurrentUser(null);
        });
  }, [reviewUrl]);

  useEffect(() => {
    if (staffData?.data?.id?.uuid && currentUser?.id?.uuid)
      sdkInstance.current.transactions
        .query({
          only: 'sale',
          userId: staffData?.data?.id?.uuid,
        })
        .then(res => {
          setIsValidReview(res.data.data?.length > 0 ? true : false);
        });
  }, []);
  useEffect(() => {
    if (reviews?.data?.length !== reviewsDB?.data?.length) {
      setReviews(reviewsDB);
    }
  });

  const handleRatingModalSubmit = async values => {
    // if (alreadyRatedByCurrentUser) return;
    setSubmitReviewLoading(true);
    const apiBody = {
      isProvider,
      values,
      businessId: currentUser.id.uuid,
      currentUserName: `${currentUser.attributes.profile.firstName} ${currentUser.attributes.profile.lastName}`,
      workerId: staffData?.data?.id.uuid,
      otherUserName: StaffName || '',
      industryType: currentUser.attributes.profile?.publicData?.industryType,
    };
    const url = `${apiBaseUrl()}/api/reviews/submitReview/provider`;
    axios
      .post(url, apiBody)
      .then(res => {
        setOpenRateModal(false);
        formRef.current.reset();
        setAlreadyRatedByCurrentUser({ isReviewed: true, reviewId: res.data._id.toString() });
        setSubmitReviewLoading(false);
        const newReviewsArr = (reviews.data || []).filter(r => r._id !== res.data._id);
        newReviewsArr.push(res.data);
        setReviews({ data: newReviewsArr, metadata: { ...reviews.metadata } });
        reviewsDB.data = newReviewsArr;
      })
      .catch(e => {
        setOpenRateModal(false);
        formRef.current.reset();
        setSubmitReviewLoading(false);
      });
  };

  const handleRateBusiness = () => {
    setOpenRateModal(true);
  };

  const handleSend = _id => {
    if (_id && reply) {
      const newReviewsState = reviews.data.map(r => {
        if (r._id !== _id) return r;
        const returnObj = { ...r, reply: reply.text };
        return returnObj;
      });
      axios
        .post(`${apiBaseUrl()}/api/reviews/addReply`, { _id, reply: reply.text })
        .then(res => {
          setReviews({ metadata: reviews.metadata, data: newReviewsState });
          setClickedIndex(null);
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  const handleRatingDetailView = e => {
    if (disableForShow) return;
    setDetailReviewClick(!detailReviewClick);
  };

  const handleReply = indx => {
    if (clickedIndex === indx) {
      return setClickedIndex(null);
    } else {
      return setClickedIndex(indx);
    }
    // if (typeof clickedIndex === 'undefined' || clickedIndex === null) {
    //   return setClickedIndex(indx);
    // }
  };

  let total_communication_punctuality = 0;
  let total_workload_presentation = 0;
  let total_expectation_efficiency = 0;
  let total_condition_collaboration = 0;
  const totalRating =
    reviews?.data?.length > 0
      ? reviews.data.reduce((acc, curr, idx) => {
          const {
            communication_punctuality,
            workload_presentation,
            expectation_efficiency,
            condition_collaboration,
          } = curr;
          const sum =
            communication_punctuality +
            workload_presentation +
            expectation_efficiency +
            condition_collaboration;

          let newCoPuTotal =
            total_communication_punctuality + communication_punctuality / reviews?.data?.length;
          let newWoPrTotal =
            total_workload_presentation + workload_presentation / reviews?.data?.length;
          let newExEfTotal =
            total_expectation_efficiency + expectation_efficiency / reviews?.data?.length;
          let newCoCoTotal =
            total_condition_collaboration + condition_collaboration / reviews?.data?.length;

          total_communication_punctuality = newCoPuTotal;
          total_workload_presentation = newWoPrTotal;
          total_expectation_efficiency = newExEfTotal;
          total_condition_collaboration = newCoCoTotal;

          return acc + sum / 4;
        }, 0)
      : 0;
  const reviewCount = reviews?.data?.length || totalRating;
  const ratingCount = parseFloat(
    Number.isNaN(totalRating / reviewCount) ? 0 : totalRating / reviewCount
  ).toFixed(1);

  const messagePlaceholder = intl.formatMessage({
    id: 'ContactUsForm.messagePlaceholder',
  });

  return (
    <>
      <div>
        <div className={css.HeadingWrapper}>
          <div onClick={handleRatingDetailView} className={css.ProfileHeading}>
            <span>
              {isProvider ? (
                <div>
                  <FormattedMessage id="RatingAndComments.profileRating" />
                </div>
              ) : (
                <FormattedMessage id="RatingAndComments.profileReview" />
              )}{' '}
            </span>

            {detailReviewClick ? (
              <span>
                <UpArrow />
              </span>
            ) : (
              <span>
                <DownArrow />
              </span>
            )}
          </div>
          {write && isProvider && isValidReview ? (
            <InlineTextButton
              type="button"
              className={css.writeAReview}
              onClick={handleRateBusiness}
              // disabled={alreadyRatedByCurrentUser || disableForShow}
              disabled={disableForShow}
            >
              <FormattedMessage id="RatingAndComments.WriteAreview" />
            </InlineTextButton>
          ) : null}
        </div>

        {detailReviewClick && !disableForShow ? (
          <div className={css.DetailRatingDiv}>
            <div className={css.ratingDiv}>
              <span>
                {/* <FieldReviewRating
                      id={`rate1`}
                      name="rating"
                      className={css.FieldReviewRating1}
                    /> */}
                <StarRating rating={ratingCount} />
              </span>
              <span className={css.ratingCount}>{ratingCount} out of 5</span>
            </div>
            {staffDataIsProvider ? (
              <div className={css.detailRatingWrapper}>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.CommunicationAndFeedBack" />
                    <span id="communicationAndFeedBack" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="communicationAndFeedBack"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="ReviewModal.CommunicationAndFeedBackDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseFloat(total_communication_punctuality || 0).toFixed(1)}</span>
                    <span>
                      <StarRating
                        rating={parseFloat(total_communication_punctuality || 0).toFixed(1)}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.workLoad" />
                    <span id="workLoad" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="workLoad"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.workLoadDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseInt(total_workload_presentation).toFixed(1)}</span>
                    <span>
                      <StarRating rating={parseInt(total_workload_presentation).toFixed(1)} />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.clearexpectation" />
                    <span id="clearexpectation" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="clearexpectation"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.clearexpectationDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseInt(total_expectation_efficiency).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate3`}
                            name="rating3"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating rating={parseInt(total_expectation_efficiency).toFixed(1)} />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.safeWorking" />
                    <span id="safeWorking" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="safeWorking"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.safeWorkingDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseInt(total_condition_collaboration).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate4`}
                            name="rating4"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating rating={parseInt(total_condition_collaboration).toFixed(1)} />
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className={css.detailRatingWrapper}>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.Punctuality" />
                    <span id="Punctuality" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="Punctuality"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="ReviewModal.PunctualityDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseFloat(total_communication_punctuality || 0).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate1`}
                            name="rating"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating
                        rating={parseFloat(total_communication_punctuality || 0).toFixed(1)}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.Presentation" />
                    <span id="Presentation" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="Presentation"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.PresentationDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseFloat(total_workload_presentation || 0).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate1`}
                            name="rating"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating
                        rating={parseFloat(total_workload_presentation || 0).toFixed(1)}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.Efficiency" />
                    <span id="Efficiency" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="Efficiency"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.EfficiencyDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseFloat(total_expectation_efficiency || 0).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate1`}
                            name="rating"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating
                        rating={parseFloat(total_expectation_efficiency || 0).toFixed(1)}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(css.ratingpointContainer, ratingPointContainerClassName)}
                >
                  <span className={css.ratingPoing}>
                    <FormattedMessage id="RatingAndComments.Collaboration" />
                    <span id="Collaboration" className={css.tooltipIcon}>
                      <InfoIcon />
                    </span>

                    <ReactTooltip
                      anchorId="Collaboration"
                      place="right"
                      effect="solid"
                      clickable={false}
                      className={css.categoryTooltip}
                      content={<FormattedMessage id="RatingAndComments.CollaborationDesc" />}
                    />
                  </span>
                  <div className={css.ratingDiv}>
                    <span>{parseFloat(total_condition_collaboration || 0).toFixed(1)}</span>
                    <span>
                      {/* <FieldReviewRating
                            id={`rate1`}
                            name="rating"
                            className={css.FieldReviewRating1}
                          /> */}
                      <StarRating
                        rating={parseFloat(total_condition_collaboration || 0).toFixed(1)}
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={css.ratingDiv}>
            <span>{ratingCount}</span>
            <span>
              {/* <FieldReviewRating
                    id={`rate1`}
                    name="rating"
                    className={css.FieldReviewRating1}
                  /> */}
              <StarRating rating={ratingCount} />
            </span>
          </div>
        )}
        {showDetailedReviews ? (
          <React.Fragment>
            <div className={css.hDivider}></div>
            {/*/// have to map this div for multiple comments ------------------------*/}
            {/* conditions required------------------------------ */}
            {reviews?.data?.length > 0 ? (
              reviews?.data?.map((m, indx) => {
                const {
                  workload_presentation,
                  expectation_efficiency,
                  condition_collaboration,
                  communication_punctuality,
                  message: messageDB,
                  reply: replyDB,
                  extraData: { businessName, workerName },
                  _id,
                  to,
                  workerId,
                  businessId,
                } = m;
                const industryType = 'Construction';
                const indvRating = parseFloat(
                  (parseInt(workload_presentation || 0) +
                    parseInt(expectation_efficiency || 0) +
                    parseInt(condition_collaboration || 0) +
                    parseInt(communication_punctuality || 0)) /
                    4
                ).toFixed(1);
                const category = 'Hotel/Valet';
                const isValidReplier =
                  !isSuperAdmin && to === 'worker'
                    ? currentUser?.id?.uuid === workerId
                    : currentUser?.id?.uuid === businessId;
                return (
                  <div key={indx}>
                    <div className={css.CommentContainerWrapper} key={indx}>
                      <div className={css.commentcontainer}>
                        <div className={css.ratingDiv}>
                          <span>{indvRating}</span>
                          <span>
                            <StarRating rating={indvRating} />
                          </span>
                        </div>
                        <div className={css.businessProfileDetailsWrapper}>
                          <div className={css.imgTag}>
                            {/* conditions required------------------------------ */}
                            {false ? (
                              <>
                                <img src="" className={css.profileImg} />
                              </>
                            ) : (
                              <BlankProfileImg className={css.profileImg} />
                            )}
                          </div>
                          <div className={css.businessdetailsDiv}>
                            <div className={css.Name}>
                              {to === 'worker' ? businessName : workerName}
                            </div>
                            <div className={css.category}>
                              {' '}
                              {to === 'worker' ? industryType : category}
                            </div>
                            <div className={css.commentAndReply}>
                              <div className={css.comments}>
                                {(messageDB || '').length > 300 &&
                                !reviewsSeeMore.includes(`message${indx}`)
                                  ? `${messageDB.substring(0, 300)}...`
                                  : messageDB}
                                {(messageDB || '').length > 300 ? (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const key = `message${indx}`;
                                      if (reviewsSeeMore.includes(key)) {
                                        setReviewsSeeMore(reviewsSeeMore.filter(f => f !== key));
                                      } else {
                                        setReviewsSeeMore([...reviewsSeeMore, key]);
                                      }
                                    }}
                                  >
                                    {reviewsSeeMore.includes(`message${indx}`)
                                      ? 'Read less'
                                      : 'Read more'}
                                  </button>
                                ) : null}
                              </div>
                              {replyDB === '' && isValidReplier ? (
                                <button
                                  type="button"
                                  className={classNames(css.reply, {
                                    [css.disbledWrite]: disableForShow,
                                  })}
                                  onClick={() => handleReply(indx)}
                                  disabled={disableForShow}
                                >
                                  <FormattedMessage id="RatingAndComment.reply" />
                                </button>
                              ) : null}
                              {clickedIndex === indx && replyDB === '' ? (
                                <div className={css.commentDiv}>
                                  <div className={css.commentheading}>
                                    <FormattedMessage id="ReviewModal.CommentHeading" />
                                  </div>
                                  <div className="textfield">
                                    {' '}
                                    <textarea
                                      type="text"
                                      value={
                                        clickedIndex === indx && reply?._id === _id
                                          ? reply?.text
                                          : ''
                                      }
                                      autoComplete="message"
                                      onChange={e => {
                                        const value = e.target.value;
                                        setReply({ text: value, _id });
                                      }}
                                      placeholder={messagePlaceholder}
                                    ></textarea>
                                  </div>

                                  <Button
                                    type="button"
                                    className={css.modalSubmitBtn}
                                    disabled={
                                      clickedIndex === indx && reply?._id === _id && !!reply?.text
                                        ? false
                                        : true
                                    }
                                    onClick={() => handleSend(_id)}
                                  >
                                    <FormattedMessage id="ContactUsForm.signUp" />
                                  </Button>
                                </div>
                              ) : null}

                              {/* after reply Showing Div ----------------------------------------*/}
                              {replyDB && (
                                <div className={css.businessProfileDetailsWrapper}>
                                  <div className={css.imgTag}>
                                    {false ? (
                                      <>
                                        <img src="" className={css.profileImg} />
                                      </>
                                    ) : (
                                      <BlankProfileImg className={css.profileImg} />
                                    )}
                                  </div>
                                  <div className={css.businessdetailsDiv}>
                                    <div className={css.Name}>
                                      {to === 'business' ? businessName : workerName}
                                    </div>
                                    <div className={css.category}>Assistant Clark</div>
                                    <div className={css.commentAndReply}>
                                      <div className={css.comments}>
                                        {(replyDB || '').length > 300 &&
                                        !reviewsSeeMore.includes(`reply${indx}`)
                                          ? `${replyDB.substring(0, 300)}...`
                                          : replyDB}
                                        {(replyDB || '').length > 300 ? (
                                          <button
                                            type="button"
                                            onClick={() => {
                                              const key = `reply${indx}`;
                                              if (reviewsSeeMore.includes(key)) {
                                                setReviewsSeeMore(
                                                  reviewsSeeMore.filter(f => f !== key)
                                                );
                                              } else {
                                                setReviewsSeeMore([...reviewsSeeMore, key]);
                                              }
                                            }}
                                          >
                                            {reviewsSeeMore.includes(`reply${indx}`)
                                              ? 'Read less'
                                              : 'Read more'}
                                          </button>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={css.NoRatingDiv}>
                <div>
                  <NoRating />
                </div>
                <div className={css.NoRatingMsg}>
                  {isProvider && !isSuperAdmin ? (
                    <FormattedMessage id="Rating.NoreviewMsg" />
                  ) : (
                    <FormattedMessage id="Rating.NoratingMsg" />
                  )}
                </div>
              </div>
            )}
          </React.Fragment>
        ) : null}
      </div>
      <Modal
        id="BookingPanel.ratingModal"
        isOpen={!!openRateModal}
        // isOpen={true}
        onClose={() => {
          const values = formRef.current.getState().values;
          ['collaboration', 'efficiency', 'presentation', 'punctuality'].map(item => {
            if (values[item]) {
              const key = `${item}.star${values[item]}`;
              document.getElementById(key).checked = false;
            }
          });
          setOpenRateModal(false);
          formRef.current.batch(() => {
            formRef.current.change('collaboration', undefined);
            formRef.current.change('efficiency', undefined);
            formRef.current.change('presentation', undefined);
            formRef.current.change('punctuality', undefined);
            formRef.current.change('message', null);
          });

          // handleBookingInProgress(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
      >
        <FinalForm
          {...props}
          initialValues={businessOldReview}
          mutators={{ ...arrayMutators }}
          onSubmit={handleRatingModalSubmit}
          render={fieldRenderProps => {
            const { handleSubmit, intl, values, staffData, form } = fieldRenderProps;
            if (!formRef.current) formRef.current = form;

            const messagePlaceholder = intl.formatMessage({
              id: 'ReviewModal.messagePlaceholder',
            });
            const StaffName = staffData?.data?.attributes?.profile?.displayName;

            const StaffId = staffData?.data?.attributes?.profile?.publicData?.customId;
            const ProfileImage = staffData?.included
              ? staffData?.included?.[0]?.attributes?.variants?.default?.url
              : undefined;

            const profileVerified =
              staffData?.data?.attributes?.profile?.metadata?.isProfileVerified;
            const currentRating = parseFloat(
              (parseInt(values?.punctuality || 0) +
                parseInt(values?.presentation || 0) +
                parseInt(values?.efficiency || 0) +
                parseInt(values?.collaboration || 0)) /
                4
            ).toFixed(1);
            return (
              <Form onSubmit={handleSubmit}>
                <div className={css.ReviewModalWrapper}>
                  <div className={css.HeadingModalContainer}>
                    <div className={css.reviewmodalHeading}>
                      <FormattedMessage id="ReviewModal.ProvideFeedbackWorker" />
                    </div>
                    <div className={css.modalsubHeading}>
                      <FormattedMessage id="ReviewModal.subHeadingWorker" />
                    </div>
                  </div>
                  <div className={css.businessDeatilsContainer}>
                    <div className={css.businessNameAndImg}>
                      {ProfileImage !== undefined ? (
                        <div className={css.businessImg}>
                          <img src={ProfileImage} alt={StaffName} className={css.profileImg} />
                        </div>
                      ) : (
                        <BlankProfileImg className={css.profileImg} />
                      )}
                      <div className={css.busienssInfoDiv}>
                        <div className={css.businessName}>
                          {StaffName}...
                          {profileVerified && <VerifiedTickComponent />}
                        </div>
                        <div className={css.businessId}>
                          <span>
                            {' '}
                            <FormattedMessage id="ProfileSettingsPage.workerID" />
                          </span>{' '}
                          {StaffId}
                        </div>
                      </div>
                    </div>
                    <div className={css.RatingContainer}>
                      <div>
                        {' '}
                        <FormattedMessage id="ReviewModal.overallRating" />
                      </div>
                      <div className={css.ratingDiv}>
                        <span>{currentRating}</span>
                        <span>
                          {/* <FieldReviewRating
                              id={`rate1`}
                              name="rating"
                              className={css.FieldReviewRating1}
                            /> */}
                          <StarRating rating={currentRating} />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={css.RatingDetails}>
                    <div className={css.pointContainer}>
                      <div className={css.pointHeading}>
                        <FormattedMessage id="RatingAndComments.Punctuality" />
                      </div>
                      <div className={css.pointsubHeading}>
                        <FormattedMessage id="ReviewModal.PunctualityDesc" />
                      </div>
                      <div className={css.ratingDiv}>
                        {/* <span>0.0</span> */}
                        <span>
                          <FieldReviewRating
                            id={`punctuality`}
                            name="punctuality"
                            className={css.FieldReviewRating1}
                            typ="radio"
                          />
                        </span>
                      </div>
                    </div>
                    <div className={css.pointContainer}>
                      <div className={css.pointHeading}>
                        <FormattedMessage id="RatingAndComments.Presentation" />
                      </div>
                      <div className={css.pointsubHeading}>
                        <FormattedMessage id="RatingAndComments.PresentationDesc" />
                      </div>
                      <div className={css.ratingDiv}>
                        {/* <span>0.0</span> */}
                        <span>
                          <FieldReviewRating
                            id={`presentation`}
                            name="presentation"
                            className={css.FieldReviewRating1}
                            typ="radio"
                          />
                        </span>
                      </div>
                    </div>
                    <div className={css.pointContainer}>
                      <div className={css.pointHeading}>
                        <FormattedMessage id="RatingAndComments.Efficiency" />
                      </div>
                      <div className={css.pointsubHeading}>
                        <FormattedMessage id="RatingAndComments.EfficiencyDesc" />
                      </div>
                      <div className={css.ratingDiv}>
                        {/* <span>0.0</span> */}
                        <span>
                          <FieldReviewRating
                            id={`efficiency`}
                            name="efficiency"
                            className={css.FieldReviewRating1}
                            typ="radio"
                          />
                        </span>
                      </div>
                    </div>
                    <div className={css.pointContainer}>
                      <div className={css.pointHeading}>
                        <FormattedMessage id="RatingAndComments.Collaboration" />
                      </div>
                      <div className={css.pointsubHeading}>
                        <FormattedMessage id="RatingAndComments.CollaborationDesc" />
                      </div>
                      <div className={css.ratingDiv}>
                        {/* <span>0.0</span> */}
                        <span>
                          <FieldReviewRating
                            id={`collaboration`}
                            name="collaboration"
                            className={css.FieldReviewRating1}
                            typ="radio"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={css.commentDiv}>
                    <div className={css.commentheading}>
                      <FormattedMessage id="ReviewModal.CommentHeading" />
                    </div>
                    <FieldTextInput
                      className={'textfield'}
                      type="textarea"
                      name="message"
                      autoComplete="message"
                      // id={messageId}
                      // label={messageLabel}
                      // validate={messageRequired}
                      placeholder={messagePlaceholder}
                    />
                    <Button
                      // type="button"
                      inProgress={submitReviewLoading}
                      className={css.modalSubmitBtn}
                      disabled={Object.keys(values).length === 0}
                    >
                      <FormattedMessage id="SignupForm.notAllowedBtnText" />
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        />
      </Modal>
    </>
  );
}

export default RatingAndComment;
